import React from 'react';
import { testimonials } from '../data/mockData';
import { Star, Quote } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const TestimonialCard = ({ t, index }) => {
  const card = useScrollAnimation({ threshold: 0.1 });

  return (
    <div
      ref={card.ref}
      data-testid={`testimonial-card-${t.id}`}
      className={`group bg-white rounded-2xl p-7 border border-zinc-100 transition-all duration-500 hover:shadow-[0_20px_50px_rgba(124,58,237,0.15)] hover:-translate-y-2 scroll-fade-up scroll-delay-${(index % 3) + 1} ${card.isVisible ? 'scroll-visible' : ''}`}
    >
      <div className="flex items-center gap-1 mb-4">
        {[...Array(t.rating)].map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
        ))}
      </div>

      <div className="mb-1">
        <Quote className="w-8 h-8 text-[#7C3AED]/20" />
      </div>

      <blockquote className="text-sm text-zinc-600 leading-relaxed mb-6">
        {t.content}
      </blockquote>

      <div className="flex items-center gap-3 pt-4 border-t border-zinc-100">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#7C3AED] to-[#14B8A6] flex items-center justify-center text-white font-bold text-sm shadow-md">
          {t.name.charAt(0)}
        </div>
        <div>
          <div className="font-semibold text-sm text-zinc-900">{t.name}</div>
          <div className="text-xs text-zinc-400">{t.role}</div>
        </div>
        <span className="ml-auto text-[10px] font-medium text-[#7C3AED] bg-[#7C3AED]/10 px-2.5 py-1 rounded-full">
          {t.service}
        </span>
      </div>
    </div>
  );
};

const TestimonialsSection = () => {
  const header = useScrollAnimation({ threshold: 0.15 });

  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 md:py-32 bg-zinc-50 relative overflow-hidden">
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-[#14B8A6]/5 blur-[100px]" />

      <div className="mx-auto w-full max-w-7xl px-4 md:px-8 relative z-10">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-16 scroll-fade-up ${header.isVisible ? 'scroll-visible' : ''}`}>
          <span className="inline-block bg-[#14B8A6]/10 text-[#14B8A6] px-4 py-1.5 rounded-full text-xs font-bold tracking-wide mb-4">
            CLIENT STORIES
          </span>
          <h2 className="text-4xl sm:text-5xl font-black tracking-tight text-zinc-900 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
            What Our Clients Say
          </h2>
          <p className="text-base text-zinc-500 leading-relaxed">
            Real feedback from businesses that trusted us with their brand protection.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.slice(0, 6).map((t, index) => (
            <TestimonialCard key={t.id} t={t} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
